import { type TableSelectedCell, useTableRows } from '@/components/custom/erp/input-table-v2';

export interface AdvSettlementRow {
  uuid: string;
  line?: number;
  [key: string]: MuaHangRecord;
}

export type SelectedCellInfo = TableSelectedCell;

export function useAdvSettlementRows(initialRows: AdvSettlementRow[] = []) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<AdvSettlementRow>({
    initialRows,
    defaultRows: 0,
    defaultField: 'dien_giai'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    handleCellValueChange,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
